export default __webpack_public_path__ + "static/media/143.5b55880a.png";